import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    CircularProgress
} from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';
import { red } from '@mui/material/colors';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

const DeleteProductModal = ({
    open,
    onClose,
    onDelete,  // <-- changed from onConfirm
    loading
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <MDBox component="form" onSubmit={onDelete}>
                <DialogTitle>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <WarningIcon style={{ color: red[700], fontSize: 40 }} />
                        </Grid>
                        <Grid item>
                            <MDTypography variant="h6" component="span">
                                Confirm Delete
                            </MDTypography>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <MDBox p={2} style={{ backgroundColor: red[50], borderLeft: `5px solid ${red[700]}` }}>
                        <MDTypography variant="body1">
                            Are you sure you want to delete this product? This action cannot be undone.
                        </MDTypography>
                    </MDBox>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={onClose} style={{ color: 'gray' }}>Cancel</MDButton>
                    <MDButton type="submit" color="primary" disabled={loading}>
                        {loading ? <CircularProgress size={24} color="inherit" /> : "Delete"}
                    </MDButton>
                </DialogActions>
            </MDBox>
        </Dialog>
    );
};

export default DeleteProductModal;
